<script>
    export let currentUrl;
</script>
<div class="loader">
    <div class="loader-inner">
         <div class="loader-fact round-corner">
            <img src="./img/co2.png" alt="Ein aufgeklapptes Laptop aus dem eine Wolke CO2 kommt">
            <p>Das Internet stößt genau so viel CO2 aus, wie der gesamte globale Flugverkehr</p>
        </div>
        <p>Ergebnisse für <strong>{currentUrl}</strong> werden geladen.</p>
        <p>Je nach Größe der zu analysierenden Seite kann dies eine Weile dauern.</p>
        <span class="lds-dual-ring"></span>
    </div>
</div>  
<style>

.loader-fact{
    background-color: white;
    padding: 1em;

    color: black;
    font-size: medium;

    display: flex;
    flex-direction: column;
    align-items: center;
}

@media only screen and (max-width: 320px) {
  .loader-fact img {
    width: 200px;
  }
}

.loader {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    z-index: 20;
    display: flex;
    flex-direction: column;
    color: white;
    align-items: center;
    justify-content: center;
}

.loader-inner{
    background-color: var(--ci-red);
    padding: 1em;

    display: flex;
    flex-direction: column;
    align-items: center;
}

.loader-inner p{
  text-align: center;
}

.lds-dual-ring {
  display: inline-block;
  width: 50px;
  height: 50px;
}

.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 4px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>